/**
 * Overlay-related semantic tokens for PrimeNG preset.
 * Modal uses modalTokens from the component layer.
 */
import { nbxVar } from '../../tokens/generated/nbx-tokens.js';
import { createModalTokens, modalTokens } from '../tokens/components.js';
import * as p from '../tokens/primitives.js';
import { type SemanticTokens, border, layout, surface, text } from '../tokens/semantic.js';

export const overlays = {
  // Overlay tokens
  overlay: {
    select: {
      borderRadius: p.borderRadius[8],
      shadow: nbxVar('shadow.overlay-md'),
      background: surface.ground,
      border: {
        color: border.divider,
        radius: p.borderRadius[8],
      },
      color: text.secondary,
    },
    popover: {
      borderRadius: p.borderRadius[8],
      padding: layout.padding.sm,
      shadow: nbxVar('shadow.overlay-sm'),
      border: {
        radius: p.borderRadius[8],
      },
    },
    modal: {
      borderRadius: modalTokens.base.radius,
      padding: modalTokens.base.paddingX,
      shadow: nbxVar('shadow.overlay-lg'),
      border: {
        radius: modalTokens.base.radius,
      },
    },
  },
};

export function createOverlays(s: SemanticTokens, mt: ReturnType<typeof createModalTokens>) {
  return {
    overlay: {
      select: {
        borderRadius: p.borderRadius[8],
        shadow: nbxVar('shadow.overlay-md'),
        background: s.surface.ground,
        border: {
          color: s.border.divider,
          radius: p.borderRadius[8],
        },
        color: s.text.secondary,
      },
      popover: {
        borderRadius: p.borderRadius[8],
        padding: s.layout.padding.sm,
        shadow: nbxVar('shadow.overlay-sm'),
        border: {
          radius: p.borderRadius[8],
        },
      },
      modal: {
        borderRadius: mt.base.radius,
        padding: mt.base.paddingX,
        shadow: nbxVar('shadow.overlay-lg'),
        border: {
          radius: mt.base.radius,
        },
      },
    },
  };
}
